import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'

export default function DuplicateSetButton({ mode, phaseType, phaseIndex, exerciseIndex, setIndex, mutateExercise }) {
    if (mode === 'edit' && phaseType === 'straight') {
        return (
            <button
                title="Duplicate Set"
                // className='text-gray-500 hover:text-gray-400'
                className="h-10 w-10 flex justify-center items-center border-r border-stone-400 hover:bg-gray-200"
                onClick={() => mutateExercise('duplicate-set', phaseIndex, exerciseIndex, setIndex)}
            >
                <DocumentDuplicateIcon className="h-5 pointer-events-none" />
            </button>
        )
    }
}
